export function getQueryParams(): Record<string, string> {
  const queryParameters: Record<string, string> = {};

  const searchParams = new URLSearchParams(window.location.search);
  searchParams.forEach((value, key) => {
    try {
      queryParameters[key] = decodeURIComponent(String(value));
    } catch {
      queryParameters[key] = String(value);
    }
  });

  return queryParameters;
}
